type Confirmation = (allowed: boolean) => void;
type Handler = (confirm: Confirmation) => void;

const handlers = new Map<string, Handler>();

export function registerNavigationConfirmation(message: string, handler: Handler) {
    handlers.set(message, handler);
    return () => {
        if (handlers.get(message) === handler) {
            handlers.delete(message);
        }
    };
}

/** Let history resume the original PUSH, REPLACE or POP after an application dialog. */
export function confirmNavigation(message: string, confirm: Confirmation) {
    const handler = handlers.get(message);
    if (handler) {
        handler(confirm);
    } else {
        confirm(window.confirm(message));
    }
}
